import React from 'react'
import { Input, Space } from 'antd'
import { PortalArticleQuickSummary } from '../../../../models/PortalArtigoModel'
import { createDefaultQuickSummary } from '../../helpers/block-defaults'
import { PortalEditorField } from '../PortalEditorField'
import { RichTextField, RichTextListEditor } from '../PortalRichTextFields'

interface QuickSummaryEditorProps {
  value: PortalArticleQuickSummary
  onChange: (quickSummary: PortalArticleQuickSummary) => void
}

export function QuickSummaryEditor({ value, onChange }: QuickSummaryEditorProps) {
  const quickSummary = value || createDefaultQuickSummary()

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <PortalEditorField label="Título do resumo">
        <Input
          value={quickSummary.title}
          placeholder="Resumo rápido:"
          onChange={(event) => onChange({ ...quickSummary, title: event.target.value })}
        />
      </PortalEditorField>
      <RichTextField
        label="Parágrafo"
        value={quickSummary.paragraph}
        onChange={(paragraph) => onChange({ ...quickSummary, paragraph })}
      />
      <RichTextListEditor
        label="Marcadores"
        addLabel="Adicionar marcador"
        value={quickSummary.items || []}
        onChange={(items) => onChange({ ...quickSummary, items })}
      />
    </Space>
  )
}
